export interface CourtScheduleItem {
  id?: number;
  documentId?: string;
  dayOfWeek: string;
  startTime: string;
  endTime: string;
  priceCents: number;
}

export const DAY_OF_WEEK_LABELS: Record<string, string> = {
  lunes: 'Lunes',
  martes: 'Martes',
  miercoles: 'Miércoles',
  jueves: 'Jueves',
  viernes: 'Viernes',
  sabado: 'Sábado',
  domingo: 'Domingo',
  festivo: 'Festivo',
};

export const DAY_OF_WEEK_OPTIONS: { value: string; label: string }[] = Object.entries(
  DAY_OF_WEEK_LABELS,
).map(([value, label]) => ({ value, label }));
